import React from 'react';
import {
	Box,
	Button,
	Chip,
	Divider,
	Grid,
	Stack,
	TextField,
	Typography,
} from '@mui/material';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import LogoUpload from '../../../Components/Settings/LogoUpload';
import { SectionCard, SectionHeader } from '../components/SettingsShell';

const CompanySection = ({
	organization,
	formData,
	saving,
	stripeReady,
	onInputChange,
	onSave,
	onOrganizationUpdated,
	onSuccess,
	onError,
}) => (
	<SectionCard id="onboarding-branding">
		<SectionHeader
			icon={BusinessOutlinedIcon}
			title="Company"
			description="Logo, contact details, and mailing address shown on proposals and invoices."
			titleAdornment={
				stripeReady ? (
					<Chip
						label="Stripe connected"
						size="small"
						color="success"
						variant="outlined"
					/>
				) : null
			}
		/>

		<Stack spacing={{ xs: 2.5, sm: 3 }}>
			<Box>
				<Stack
					direction="row"
					spacing={1.25}
					alignItems="center"
					sx={{ mb: 1.5 }}
				>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							width: 32,
							height: 32,
							borderRadius: 2,
							bgcolor: 'action.hover',
							color: 'primary.main',
						}}
					>
						<ImageOutlinedIcon sx={{ fontSize: 18 }} />
					</Box>
					<Typography variant="subtitle1" fontWeight={700}>
						Company logo
					</Typography>
				</Stack>
				<LogoUpload
					organization={organization}
					onUpdated={onOrganizationUpdated}
					onSuccess={onSuccess}
					onError={onError}
				/>
			</Box>

			<Divider />

			<Box component="form" onSubmit={onSave} noValidate>
				<Stack spacing={{ xs: 2, sm: 2.5 }}>
					<Grid container spacing={{ xs: 2, sm: 2.5 }}>
						<Grid item xs={12} sm={6}>
							<TextField
								label="Invoice payee"
								name="invoice_payee"
								value={formData.invoice_payee}
								onChange={onInputChange}
								fullWidth
								required
								placeholder="Business name on checks"
								helperText="Name customers should make checks payable to"
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								label="From email"
								name="from_email"
								type="email"
								value={formData.from_email}
								onChange={onInputChange}
								fullWidth
								placeholder="billing@yourbusiness.com"
								helperText="Reply-to for customer emails; also BCC'd on bid reminders."
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								label="Phone"
								name="phone"
								value={formData.phone}
								onChange={onInputChange}
								fullWidth
								placeholder="(801) 555-1234"
								helperText="Shown in customer emails"
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								label="Tax ID / EIN"
								name="tax_id"
								value={formData.tax_id}
								onChange={onInputChange}
								fullWidth
								placeholder="12-3456789"
								helperText="Optional. Shown in email footers"
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								id="onboarding-mailing-address"
								label="Invoice mailing address"
								name="invoice_mailing_address"
								value={formData.invoice_mailing_address}
								onChange={onInputChange}
								fullWidth
								required
								multiline
								maxRows={6}
								placeholder={'123 Main St\nCity, ST 12345'}
								helperText="Where customers should mail check payments"
							/>
						</Grid>
					</Grid>

					<Box
						sx={{
							display: 'flex',
							justifyContent: { xs: 'stretch', sm: 'flex-end' },
						}}
					>
						<Button
							type="submit"
							variant="contained"
							disabled={saving}
							sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 160 } }}
						>
							{saving ? 'Saving...' : 'Save changes'}
						</Button>
					</Box>
				</Stack>
			</Box>
		</Stack>
	</SectionCard>
);

export default CompanySection;
